const cosmeticsProductTypes = {
  skincare: {
    lip: {
      lipBalm: 'LipBalm',
    },

    eye: {
      eyeMasks: 'EyeMasks',
      eyeCreamsTreatments: 'EyeCreamsTreatments',
    },

    cleansers: {
      faceWash: 'FaceWash',
      faceWipes: 'FaceWipes',
      toner: 'Toner',
      exfoliators: 'Exfoliators',
      makeupRemover: 'MakeupRemover',
    },

    masks: {
      faceMask: 'FaceMask',
      sheetMask: 'SheetMask',
    },

    moisturizers: {
      mists: 'Mists',
      faceOil: 'FaceOil',
      faceMoisturizer: 'FaceMoisturizer',
    },

    treatments: {
      serum: 'Serum',
      ampoules: 'Ampoules',
      blemishAcneSolutions: 'BlemishAcneSolutions',
    },

    mens: {
      face: 'Face',
      eye: 'Eye',
      shaving: 'Shaving',
    },

    wellness: {
      calmSootheSleep: 'CalmSootheSleep',
      energyUpgrade: 'EnergyUpgrade',
      gutHealth: 'GutHealth',
      hairSkinNail: 'HairSkinNail',
      immuneSupport: 'ImmuneSupport',
      womensHealth: 'WomensHealth',
      workout: 'Workout',
    },
  },

  personalCare: {
    bodyMoisturizers: {
      bodyMoisturizers: 'BodyMoisturizers',
    },
    handCreams: {
      handCreams: 'Cream',
    },
    shower: {
      bodyWash: 'BodyWash',
      bodyScrubs: 'Scrub',
    },
  },

  makeup: {
    palettes: {
      palette: 'Palette',
    },

    eye: {
      eyebrow: 'Eyebrow',
      eyeLiner: 'EyeLiner',
      eyeMascara: 'EyeMascara',
      eyePrimer: 'EyePrimer',
      eyeshadow: 'Eyeshadow',
    },

    lip: {
      lipLiner: 'LipLiner',
      lipstick: 'Lipstick',
      lipgloss: 'Lipgloss',
      lipColor: 'LipColor', // deprecated, moved to Lipstick
      lipColorPencil: 'LipColorPencil', // deprecated, moved to Lipstick
      lipCrayon: 'LipCrayon', // deprecated, moved to Lipstick
      lipPaint: 'LipPaint', // deprecated, moved to Lipstick
    },

    face: {
      facePrimer: 'FacePrimer',
      foundation: 'FaceFoundation',
      concealer: 'FaceConcealer',
    },

    cheek: {
      cheekBlush: 'CheekBlush',
      cheekHighlight: 'CheekHighlight',
    },

    tools: {
      brushes: 'Brushes',
    },
  },
} as const


export type CosmeticsProductTypes = typeof cosmeticsProductTypes

export default cosmeticsProductTypes
